import { normalRequest } from '@/utils/request'
export function imgToBase64 (url, type) {
  return normalRequest({
    url: url,
    method: 'get'
  }).then(data => {
    return `data:${type};base64,${data.data.slice(32)}`
  }).catch(() => {
    // 返回空字串是因為方便直接讓 img src 直接抓取空字串, 非需要再 catch error
    return ''
  })
}



// WEBPACK FOOTER //
// ./src/API/common.js